import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=18017aa4&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=18017aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18017aa4",
  null
  
)

export default component.exports